export default __webpack_public_path__ + "static/media/Model X.2fc1d9a9.png";